module.exports = __webpack_public_path__ + "static/img/our-customers-infrastructure-hero-lowres.f047bbf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-customers/our-customers-infrastructure-hero-lowres.jpg
// module id = wZuU
// module chunks = 0